import { Location } from "@reach/router";
import Headline from "global/Headline";
import React from "react";

import InnerPageNav from "components/InnerPageNav";
import zparse from "helpers/zparse";
import DataProvider from "providers/data";

const ContentPage = (props) => {
    let page = { ...props };

    if (
        (props.providerResponse.data.length > 0 || !!page !== false) &&
        props.providerStatusText === "LOADED"
    ) {
        page = { ...page, ...props.providerResponse.data[0] }; // merge custom template props into latest data
        page = { ...page, ...props.forceOptions };
    }

    return (
        <>
            <Headline
                {...{
                    preTitle: page.headlinePreTitle,
                    body: page.headlineBody,
                    title: page.headlineTitle,
                    image: page.headlineImage,
                    columnSize: page.columnSize ? page.columnSize : 9,
                    isPageHeader: true,
                    type: page.headlineType,
                    bgColor: page.headlineBgColor,
                    color: page.headlineColor,
                }}
            />
            <InnerPageNav uri={page.uri} items={props.pageNav} />
            {props.preContent}
            {!props.hideContent && (
                <section
                    id="content-page"
                    className={`content-page-${props.location.pathname.replace(
                        /\//gm,
                        ""
                    )}`}
                >
                    {page.hasOwnProperty('blocks') && !!page.blocks && page.blocks.length > 0 ?
                        page.blocks.map(block => (
                            block.fullWidth ?
                                (
                                    <div className={`content-block${block.className ? ` content-block--${block.className}` : ''}`}>
                                        {zparse(block.body)}
                                    </div>
                                ) : (
                                    <div className={`content-block${block.className ? ` content-block--${block.className}` : ''}`}>
                                        <div className="grid-container">
                                            <div className="grid-margin-x grid-x align-center">
                                                <div className={`small-12 medium-${props.gridSize ? props.gridSize : 11
                                                    } cell`}>
                                                    {zparse(block.body)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                        )) : (
                            <div className="grid-container">
                                <div className="grid-margin-x grid-x align-center">
                                    <div
                                        className={`small-12 medium-${props.gridSize ? props.gridSize : 11
                                            } cell`}
                                    >
                                        {zparse(page.content ? page.content.main : "")}
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {props.children}
                </section>
            )}
            {props.postContent}
        </>
    );
};

const Content = (props) => (
    <Location>
        {(locationProps) => (
            <DataProvider
                liveRefresh={true}
                type="ContentPage"
                apiParams={{ uri: locationProps.location.pathname, _join: true }}
            >
                <ContentPage {...props} location={locationProps.location} />
            </DataProvider>
        )}
    </Location>
);
export default Content;
